var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mt-5 mb-5"},[_c('ScheduleDashboard',{staticClass:"mt-2"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }